@if (productPage && productPage.numberOfElements > 0) {
  <div class="row">
    <div class="col-12">
      <div class="product-detail_related-products">
        <h1
          i18n="
            product detail: alternative products
            header@@product.detail.alternative-products.header"
          >
          Available similar products
        </h1>
        <div class="js-overview-grid">
          <div
            class="overview-grid overview-grid--cms hide-last-product-on-tablet"
            >
            @if (productPage) {
              @for (product of productPage.content; track product) {
                <product-item-grid
                  #productItemGridComponent
                  (lazyLoad)="productItemGridComponent.doLoad($event)"
                  (viewProductDetailClickEvent)="viewProductDetail($event)"
                  [loggedIn]="userService.isLoggedIn()"
                  [product]="product"
                  class="overview-product"
                  >
                </product-item-grid>
              }
            }
          </div>
        </div>
      </div>
    </div>
  </div>
} @else {
  <div class="row">
    <div class="col-12">
      <div class="product-detail_related-products">
        <h3
          i18n="
            product detail: alternative products
            header@@product.detail.alternative-products.not.found.header"
          >
          No alternative products available
        </h3>
      </div>
    </div>
  </div>
}

